import type {
  ComponentTwinsGroupResponseDto,
  CreateComponentTwinsGroupRequestDto,
  ListComponentTwinsGroupsResponseDto,
  UpdateComponentTwinsGroupRequestDto,
} from '@evimo/types';
import { ResponseError } from '@evimo/client/runtime';
import {
  componentTwinsGroupRequestInit,
  componentTwinsGroupsApi,
} from '~/app/services/component-twins-group/component-twins-group-api-instances';

async function readClientError(error: unknown): Promise<never> {
  if (error instanceof ResponseError) {
    const message = await error.response.text();
    throw new Error(message || `Request failed (${error.response.status})`);
  }
  throw error;
}

export const ComponentTwinsGroupService = {
  async list(
    organizationId: string,
    assetId: string,
  ): Promise<ListComponentTwinsGroupsResponseDto> {
    try {
      const result =
        await componentTwinsGroupsApi.componentTwinsGroupControllerList(
          { organizationId, assetId },
          componentTwinsGroupRequestInit,
        );
      return result as unknown as ListComponentTwinsGroupsResponseDto;
    } catch (error) {
      return readClientError(error);
    }
  },

  async create(
    organizationId: string,
    assetId: string,
    dto: CreateComponentTwinsGroupRequestDto,
  ): Promise<ComponentTwinsGroupResponseDto> {
    try {
      const result =
        await componentTwinsGroupsApi.componentTwinsGroupControllerCreate(
          {
            organizationId,
            assetId,
            createComponentTwinsGroupRequestDto: dto,
          },
          componentTwinsGroupRequestInit,
        );
      return result as unknown as ComponentTwinsGroupResponseDto;
    } catch (error) {
      return readClientError(error);
    }
  },

  async update(
    organizationId: string,
    assetId: string,
    groupId: string,
    dto: UpdateComponentTwinsGroupRequestDto,
  ): Promise<ComponentTwinsGroupResponseDto> {
    try {
      const result =
        await componentTwinsGroupsApi.componentTwinsGroupControllerUpdate(
          {
            organizationId,
            assetId,
            groupId,
            updateComponentTwinsGroupRequestDto: dto,
          },
          componentTwinsGroupRequestInit,
        );
      return result as unknown as ComponentTwinsGroupResponseDto;
    } catch (error) {
      return readClientError(error);
    }
  },

  async delete(
    organizationId: string,
    assetId: string,
    groupId: string,
  ): Promise<void> {
    try {
      await componentTwinsGroupsApi.componentTwinsGroupControllerDelete(
        { organizationId, assetId, groupId },
        componentTwinsGroupRequestInit,
      );
    } catch (error) {
      return readClientError(error);
    }
  },
};
